import { ref } from 'vue'

const LONG_PRESS_MS = 2000
const MOVE_THRESHOLD_PX = 10

export function useMobileCardTap(onTap) {
  const suppressClick = ref(false)
  const touchState = {
    active: false,
    start: 0,
    x: 0,
    y: 0,
    moved: false
  }

  function onTouchStart(event) {
    if (event.touches.length !== 1) return
    const touch = event.touches[0]
    touchState.active = true
    touchState.start = Date.now()
    touchState.x = touch.clientX
    touchState.y = touch.clientY
    touchState.moved = false
  }

  function onTouchMove(event) {
    if (!touchState.active || event.touches.length !== 1) return
    const touch = event.touches[0]
    if (
      Math.abs(touch.clientX - touchState.x) > MOVE_THRESHOLD_PX
      || Math.abs(touch.clientY - touchState.y) > MOVE_THRESHOLD_PX
    ) {
      touchState.moved = true
    }
  }

  function onTouchEnd() {
    if (!touchState.active) return
    const duration = Date.now() - touchState.start
    touchState.active = false
    if (touchState.moved || duration >= LONG_PRESS_MS) return
    suppressClick.value = true
    onTap()
    window.setTimeout(() => {
      suppressClick.value = false
    }, 400)
  }

  function onClick() {
    if (suppressClick.value) return
    onTap()
  }

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onClick
  }
}
